import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
Fancybox.bind('[data-fancybox]:not([data-fancybox="slideshow"])', {});
Fancybox.bind('[data-fancybox="slideshow"]', {
    Carousel: {
        Autoplay: {
            timeout: 4000,
            autoStart: true,
        },
    },
});
